import React, { Component, Fragment } from 'react';
import { Button, Tag, Badge, Row, Col, List, Typography, Dropdown } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from 'actions';
import * as services from 'services';
import { DecosFunc } from 'components/utils';
import './SynonymSpan.css';

const convertPumsa = pumsa => {
	switch (pumsa) {
		case 'NC':
			return '명사';
		case 'NP':
			return '대명사';
		case 'VV':
			return '동사';
		case 'VA':
			return '형용사';
		case 'MA':
			return '부사';
		default:
			return '';
	}
};

const mapStateToProps = state => ({
	filters: state.syno.filters,
	selectedItem: state.spell.selectedItem,
});

const mapDispatchToProps = dispatch => ({
	onSelectedItem: selectedItem => dispatch(actions.onSelectedItem(selectedItem)),
});

const menu = (datas, callBack, isSelected) => {
	const { title, org, count, pyojae, more, postData } = datas;
	if (!postData) return <Fragment />;
	if (!isSelected) return <Fragment />;
	return (
		<div className="dropdown-content">
			<List
				header={
					<div>
						<Row type="flex" justify="space-between">
							<Col>
								<span>
									<Tag>{pyojae && convertPumsa(pyojae.PUMSA)}</Tag>
									<Typography.Text strong>{title + org}</Typography.Text>       
								</span>
							</Col>
							<Col>
								<Badge style={{ backgroundColor: 'rgb(102, 204, 255)' }} count={count} />
							</Col>
						</Row>
					</div>
				}
				footer={
					more && (
						<Row type="flex" justify="center">
							<Col>
								<Button type="primary" shape="round" onClick={callBack.onClick} size={'small'}>
									꼬마사전 더보기
								</Button>
							</Col>
						</Row>
					)
				}
				bordered={false}
				dataSource={postData}
				locale={{
					emptyText: '조회된 유의어가 없습니다.',
				}}
				renderItem={item => {
					const key = item[0];
					const value = item[1];
					return (
						<div
							key={key ? key : 'NUL'}
							style={{
								marginTop: '10px',
								marginBottom: '10px',
							}}
						>
							<Row type="flex" justify="space-between">
								<Col>
									<Row type="flex" justify="start">
										<Col>
											<div className="arrow_box">
												<span
													style={{
														fontSize: '9px',
														marginLeft: '3px',
														marginRight: '3px',
													}}
												>
													의미 범주
												</span>
											</div>
										</Col>
										<Col
											style={{
												color: '#025798',
												marginLeft: '8px',
												fontWeight: '500',
												fontStyle: 'italic',
												textAlign: 'left!important',
											}}
										>
											{key ? <b>{key}</b> : <b>없음</b>}
										</Col>
									</Row>
								</Col>
								<Col>
									<Badge
										size="small"
										count={value.length}
										style={{
											backgroundColor: '#fff',
											color: '#999',
											boxShadow: '0 0 0 1px #d9d9d9 inset',
										}}
									/>
								</Col>
							</Row>
							<Row>
								<Col>
									<div style={{ marginLeft: '8px', marginTop: '5px' }}>
										{value
											.filter((x, k) => k < 3)
											.map((x, k) => {
												return (
													<span key={k} style={{ fontWeight: '500', fontSize: '13' }}>
														{k > 0 ? ' | ' + x.SYN_NAME : x.SYN_NAME}
													</span>
												);
											})}
										{value.length > 3 && <span> | ...</span>}
									</div>
								</Col>
							</Row>
						</div>
					);
				}}
			/>
		</div>
	);
};

class SynonymSpan extends Component {
	state = {
		title: '',
		org: '',
		count: 0,
		pyojae: null,
		more: false,
		visible: false,
		isSelected: false,
		postData: [],
	};

	onClick = e => {
		e.preventDefault();
		const { filters, pyojae } = this.state;
		let pathname = '';
		if (this.props.location.pathname.indexOf('/synonyms') > -1) {
			pathname = this.props.location.pathname;
		} else {
			pathname = this.props.match.url + '/decos/synonyms';
		}
		this.props.history.push({
			pathname: pathname,
			post: { dicCode: 'dic-syn', filters, pyojae },
		});
	};

	fetchSynonym = async (wordno, filters) => {
		const post = await services.postApi(this, '/api/sentence/synonymByOne', { wordno, filters });
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.sort((a, b) => {
					if (a.MEAN == null || b.MEAN == null) return -1;
					return 0;
				});
				const grouped = DecosFunc.groupBy(results, result => result.MEAN);
				this.setState({
					postData: [...grouped.entries()].filter((i, key) => key < 3),
				});
			}
		}
	};

	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			filters: props.filters,
		};
	}

	onDropDownClick = e => {
		const { filters, pyojae } = this.state;
		this.fetchSynonym(pyojae.wordno, filters);

		const blockKey = this.props.children[0].props.block.getKey();
		const start = this.props.children[0].props.start;
		const end = start + this.props.decoratedText.length;
		this.props.onSelectedItem({
			blockKey,
			start,
			end,
			text: this.props.decoratedText,
			offsetKey: this.props.offsetKey,
			scrollNo: false,
		});
	};

	componentDidMount() {
		this.setState({ synos: this.props.synos, decoratedText: this.props.decoratedText, changeSynos: true });
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.synos !== nextProps.synos) {
			this.setState({ synos: nextProps.synos, changeSynos: true });
		}
		if (this.props.decoratedText.trim() !== nextProps.decoratedText.trim()) {
			this.setState({ decoratedText: nextProps.decoratedText });
		}
		if (this.props.filters !== nextProps.filters) {
			this.setState({ filters: nextProps.filters });
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.changeSynos) {
			const pyojae = this.state.synos.filter(a => {
				return a.name === this.state.decoratedText.trim();
			});

			let title = '';
			let org = '';
			let count = 0;
			let more = false;

			if (pyojae[0]) {
				title = pyojae[0].PYOJAE.replace(/[0-9]/g, '');
				org = pyojae[0].ORG_LANGUAGE ? '(' + pyojae[0].ORG_LANGUAGE + ')' : '';
				count = pyojae[0].synonyms.length;
			}

			if (count > 3) {
				more = true;
			}

			this.setState({ title, org, count, pyojae: pyojae[0], more, changeSynos: false });
		}
	}

	render() {
		const blockKey = this.props.children[0].props.block.getKey();
		const start = this.props.children[0].props.start;
		const selectedItem = this.props.selectedItem;
		let isSelected = false;
		if (
			selectedItem &&
			selectedItem.blockKey === blockKey &&
			parseInt(selectedItem.start) === start &&
			selectedItem.text === this.props.decoratedText
		) {
			isSelected = true;
		} else {
			isSelected = false;
		}
		if (this.state.postData) {
			return (
				<Dropdown
					overlay={menu(this.state, this, isSelected)}
					trigger={['click']}
					data-offset-key={this.props.offsetKey}
				>
					<span
						style={{ fontWeight: 'bold' }}
						className={isSelected ? 'selected' : ''}
						onClick={e => this.onDropDownClick(e)}
					>
						{this.props.children}
					</span>
				</Dropdown>
			);
		} else {
			return <span>{this.props.children}</span>;
		}
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SynonymSpan));
